module.exports = __webpack_public_path__ + "img/collection-engagementRingsDiamond.0ecdbd1.jpg";